import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';

const ConfirmDeleteDialog = ({ open, onClose, onConfirm, pick }) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Delete Pick</DialogTitle>
      <DialogContent>
        <Typography variant="body1">Are you sure you want to delete this pick?</Typography>
        {pick && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>{pick.awayTeam} @ {pick.homeTeam} — {pick.pickedTeam}</Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button color="error" variant="contained" onClick={onConfirm}>Delete</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDeleteDialog;
